function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import * as ScanditSDK from "scandit-sdk";

import OperationQueue from "./operation-queue";

var _default = function _default() {
  var _this = this;

  _classCallCheck(this, _default);

  this.operationQueue = new OperationQueue();
  this.isInitialized = false;

  this.initialize = function (scannerContainer, props) {
    ScanditSDK.BarcodePicker.create(scannerContainer, {
      accessCamera: props.accessCamera,
      camera: props.camera,
      cameraSettings: props.cameraSettings,
      enableCameraSwitcher: props.enableCameraSwitcher,
      enableTorchToggle: props.enableTorchToggle,
      enablePinchToZoom: props.enablePinchToZoom,
      enableTapToFocus: props.enableTapToFocus,
      guiStyle: props.guiStyle,
      playSoundOnScan: props.playSoundOnScan,
      vibrateOnScan: props.vibrateOnScan,
      scanSettings: props.scanSettings,
      scanner: props.scanner,
      scanningPaused: props.paused,
      targetScanningFPS: props.targetScanningFPS,
      videoFit: props.videoFit,
      visible: props.visible,
      singleImageMode: props.singleImageMode
    }).then(function (picker) {
      picker.onReady(function () {
        props.onReady != null && props.onReady();
        props.onScannerInitialized != null && props.onScannerInitialized(picker.getScanner());
      });
      picker.onScan(function (result) {
        return props.onScan != null && props.onScan(result);
      });
      picker.onScanError(function (result) {
        return props.onScanError != null && props.onScanError(result);
      });
      picker.onProcessFrame(function (result) {
        return props.onProcessFrame != null && props.onProcessFrame(result);
      });
      picker.onSubmitFrame(function (result) {
        return props.onSubmitFrame != null && props.onSubmitFrame(result);
      });
      _this.picker = picker;
      _this.operationQueue.execute();
    });
    _this.isInitialized = true;
  };

  this.destroy = function () {
    _this.picker.destroy();
  };

  this.addToQueue = function (f) {
    if (_this.isInitialized == true) {
      _this.operationQueue.add(f);
    }
  };

  this.update = function (prevProps, props) {
    _this.setScanSettings(prevProps, props);
    _this.setScanning(prevProps, props);
    _this.setAccessCamera(prevProps, props);
    _this.setActiveCamera(prevProps, props);
    _this.setCameraSettings(prevProps, props);
    _this.setEnableCameraSwitcher(prevProps, props);
    _this.setEnableTorchToggle(prevProps, props);
    _this.setEnablePinchToZoom(prevProps, props);
    _this.setEnableTapToFocus(prevProps, props);
    _this.setGuiStyle(prevProps, props);
    _this.setPlaySoundOnScanEnabled(prevProps, props);
    _this.setVibrateOnScanEnabled(prevProps, props);
    _this.setTargetScanningFPS(prevProps, props);
    _this.setVideoFit(prevProps, props);
    _this.setVisible(prevProps, props);

    if (_this.picker != null) {
      _this.operationQueue.execute();
    }
  };

  this.setScanSettings = function (prevProps, props) {
    var shouldSet = prevProps == null || JSON.stringify(prevProps.scanSettings) != JSON.stringify(props.scanSettings);

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.applyScanSettings(props.scanSettings));
      });
    }
  };

  this.setScanning = function (prevProps, props) {
    if (_this.picker) {
      if (props.paused && !_this.picker.isScanningPaused()) {
        // should pause?
        _this.addToQueue(function () {
          return Promise.resolve(_this.picker.pauseScanning(!props.accessCamera));
        });
      } else if (!props.paused && _this.picker.isScanningPaused()) {
        // should resume?
        _this.addToQueue(function () {
          return _this.picker.resumeScanning();
        });
      }
    }
  };

  this.setAccessCamera = function (prevProps, props) {
    var shouldSet = (prevProps == null || prevProps.accessCamera != props.accessCamera) && props.accessCamera;

    if (shouldSet) {
      _this.addToQueue(function () {
        return _this.picker.accessCamera();
      });
    }
  };

  this.setActiveCamera = function (prevProps, props) {
    var shouldSet = (prevProps == null || prevProps.camera != props.camera) && props.camera != null && _this.picker.getActiveCamera() != props.camera;

    if (shouldSet) {
      _this.addToQueue(function () {
        return _this.picker.setActiveCamera(props.camera);
      });
    }
  };

  this.setCameraSettings = function (prevProps, props) {
    var shouldSet = prevProps == null || JSON.stringify(prevProps.cameraSettings) != JSON.stringify(props.cameraSettings);

    if (shouldSet) {
      _this.addToQueue(function () {
        return _this.picker.applyCameraSettings(props.cameraSettings);
      });
    }
  };

  this.setEnableCameraSwitcher = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.enableCameraSwitcher != props.enableCameraSwitcher;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setCameraSwitcherEnabled(props.enableCameraSwitcher));
      });
    }
  };

  this.setEnableTorchToggle = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.enableTorchToggle != props.enableTorchToggle;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setTorchToggleEnabled(props.enableTorchToggle));
      });
    }
  };

  this.setEnablePinchToZoom = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.enablePinchToZoom != props.enablePinchToZoom;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setPinchToZoomEnabled(props.enablePinchToZoom));
      });
    }
  };

  this.setEnableTapToFocus = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.enableTapToFocus != props.enableTapToFocus;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setTapToFocusEnabled(props.enableTapToFocus));
      });
    }
  };

  this.setGuiStyle = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.guiStyle != props.guiStyle;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setGuiStyle(props.guiStyle));
      });
    }
  };

  this.setPlaySoundOnScanEnabled = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.playSoundOnScan != props.playSoundOnScan;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setPlaySoundOnScanEnabled(props.playSoundOnScan));
      });
    }
  };

  this.setVibrateOnScanEnabled = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.vibrateOnScan != props.vibrateOnScan;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setVibrateOnScanEnabled(props.vibrateOnScan));
      });
    }
  };

  this.setTargetScanningFPS = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.targetScanningFPS != props.targetScanningFPS;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setTargetScanningFPS(props.targetScanningFPS));
      });
    }
  };

  this.setVideoFit = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.videoFit != props.videoFit;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setVideoFit(props.videoFit));
      });
    }
  };

  this.setVisible = function (prevProps, props) {
    var shouldSet = prevProps == null || prevProps.visible != props.visible;

    if (shouldSet) {
      _this.addToQueue(function () {
        return Promise.resolve(_this.picker.setVisible(props.visible));
      });
    }
  };
};

export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/scandit-sdk-react/es/picker-wrapper.js
// module id = 1380
// module chunks = 0